import { createFileRoute } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search-schema'
import ReviewTaskWorkspace from '@/pages/ReviewTaskWorkspace'

export const Route = createFileRoute('/_authenticated/review-tasks')({
  validateSearch: listSearchSchema,
  component: ReviewTaskWorkspace,
})
